import React, {Component} from 'react';
import './App.css';
import Home from "./Components/Home";
import logo from "./images/logo.png";


class App extends Component {
    state = {
        username: "admin",
        password: "admin",
        login: false
    }

    login = (e) => {
        e.preventDefault()
        if(e.target.form.username.value === this.state.username) {
            if(e.target.form.password.value === this.state.password){

                let tt = document.getElementsByClassName('alert-success')[0]
                // eslint-disable-next-line no-useless-concat
                tt.innerHTML  = "مرحبا بك"
                tt.style.display  = "block"
                setTimeout(function(){ tt.style.display = "none"; }, 2000);
                this.setState({login: true})
            } else {
                //password incorrect
                let tt = document.getElementsByClassName('alert')[0]
                tt.innerHTML  = "يرجى التحقق من كلمة المرور"
                tt.style.display  = "block"
                setTimeout(function(){ tt.style.display = "none"; }, 2000);
            }
        } else {
            //username incorrect
            let tt = document.getElementsByClassName('alert')[0]
            tt.innerHTML  = "يرجى التحقق من إسم المستخدم"
            tt.style.display  = "block"
            setTimeout(function(){
                tt.style.display = "none";
            }, 3000);
        }


    }

    hideAlert() {
        document.getElementsByClassName('alert')[0].style.display  = "none"
    }

  render() {
      if(this.state.login === false) {
          return(
              <div className="login">
                  <h1>برنامج إدارة طلبة كلية الرياضيات والإعلام الآلي</h1>
                  <div className="container">
                      <div className="form-container sign-in-container">
                          <form>
                              <h2 className="title">تسجيل الدخول</h2>
                              <input type="text" name="username" value="admin" placeholder="إسم المستخدم" />
                              <input type="password" name="password" value="admin" placeholder="كلمة المرور" />
                              <a className="password_oblie" href="/" style={{marginBottom: "5px"}}>هل نسيت كلمة المرور ؟</a>
                              <button className="button_login" onClick={this.login}>الدخول</button>
                          </form>
                      </div>
                      <div className="logo-container">
                          <img alt='' src={logo} />
                      </div>
                  </div>
                  <div className="alert-section">
                      <div className="alert" style={{display: "none", position: "absolute", alignItems: "center", bottom: 70, minWidth: "300px"}}>

                      </div>
                      <div className="alert-success" style={{display: "none", position: "absolute", bottom: 70, minWidth: "300px"}}>

                      </div>
                  </div>
              </div>
          )
      } else {
          return (
              <div>
                  <Home/>
              </div>
          )
      }
  }
}

export default App;
